import { C, CARGOS_EMPLEADO, CARGO_LABELS } from "../core/config.js";
import { state } from "../core/state.js";
import { btnStyle, escapeHTML, fmtDate, searchBox, searchFilter, today } from "../core/utils.js";

export function diasHastaCumple(fechaStr) {
  if (!fechaStr) return null;
  const parts = fechaStr.split("-");
  if (parts.length < 3) return null;
  const mes = parseInt(parts[1], 10) - 1;
  const dia = parseInt(parts[2], 10);
  const hoy = new Date(today() + "T00:00:00");
  let prox = new Date(hoy.getFullYear(), mes, dia);
  if (prox < hoy) prox = new Date(hoy.getFullYear() + 1, mes, dia);
  return Math.round((prox - hoy) / (1000*60*60*24));
}

export function calcularEdad(fechaStr) {
  if (!fechaStr) return null;
  const parts = fechaStr.split("-");
  if (parts.length < 3) return null;
  const [y,m,d] = parts.map(Number);
  const hoy = new Date(today() + "T00:00:00");
  let edad = hoy.getFullYear() - y;
  if (hoy.getMonth()+1 < m || (hoy.getMonth()+1 === m && hoy.getDate() < d)) edad--;
  return edad;
}

export function renderEmpleados() {
  const todos = state.data.empleados || [];
  const filtroCargo = state.empleadosFiltroCargo || "";
  const empleados = filtroCargo ? todos.filter(e => e.cargo === filtroCargo) : todos;
  const query = state.searches.empleados || "";
  const filtered = searchFilter(empleados, query, ["nombre","cedula","telefono","email","eps","arl","fondo_pensiones"]);

  const filtroCargoHTML = `
    <select onchange="state.empleadosFiltroCargo=this.value;render();" style="padding:8px 11px;border:1px solid ${C.border};border-radius:7px;font-size:12px;color:${C.text};background:white;">
      <option value="">Todos los cargos (${todos.length})</option>
      ${CARGOS_EMPLEADO.map(c => `<option value="${c}" ${filtroCargo===c?"selected":""}>${CARGO_LABELS[c]} (${todos.filter(e=>e.cargo===c).length})</option>`).join("")}
    </select>
  `;

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};flex-wrap:wrap;gap:10px;">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🧑‍💼 Empleados</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Administración avanzada del personal — datos de afiliaciones y cumpleaños</p>
        </div>
      </div>
      <div style="display:flex;gap:10px;align-items:center;">
        ${filtroCargoHTML}
        <button data-action="new-maestro" data-key="empleados" style="${btnStyle("#2B4A82")}">+ Nuevo empleado</button>
      </div>
    </div>
  `;

  if (todos.length === 0) {
    return `
      ${header}
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:40px;margin-bottom:10px;">🧑‍💼</div>
        <div style="color:${C.muted};font-size:14px;">Sin empleados registrados aún.</div>
        <div style="color:${C.muted};font-size:11.5px;margin-top:6px;">Haz clic en "+ Nuevo empleado" para comenzar.</div>
      </div>
    `;
  }

  if (empleados.length === 0) {
    return `
      ${header}
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:40px;margin-bottom:10px;">🔍</div>
        <div style="color:${C.muted};font-size:14px;">Ningún empleado tiene el cargo "${CARGO_LABELS[filtroCargo]||filtroCargo}".</div>
      </div>
    `;
  }

  // Estadísticas
  const porGenero = { Masculino:0, Femenino:0, Otro:0, "":0 };
  empleados.forEach(e => { porGenero[e.genero || ""] = (porGenero[e.genero || ""]||0) + 1; });

  // Próximos cumpleaños (próximos 30 días)
  const cumples = empleados
    .map(e => ({ ...e, _dias: diasHastaCumple(e.fecha_cumpleanos) }))
    .filter(e => e._dias != null)
    .sort((a,b) => a._dias - b._dias);
  const proximos = cumples.filter(e => e._dias <= 30);

  const statsHTML = `
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:9px;margin-bottom:10px;">
      <div style="background:white;border:2px solid #2B4A8230;border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">TOTAL EMPLEADOS</div>
        <div style="font-size:26px;font-weight:800;color:#2B4A82;">${empleados.length}</div>
      </div>
      <div style="background:white;border:2px solid ${C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">GÉNERO</div>
        <div style="font-size:11.5px;color:${C.text};margin-top:6px;">
          ♂ Masculino: <strong>${porGenero.Masculino||0}</strong> &nbsp; ♀ Femenino: <strong>${porGenero.Femenino||0}</strong> &nbsp; ⚧ Otro: <strong>${porGenero.Otro||0}</strong>
        </div>
      </div>
      <div style="background:${proximos.length>0?"#fffbeb":"white"};border:2px solid ${proximos.length>0?C.amber:C.border};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">🎂 CUMPLEAÑOS PRÓXIMOS (30 DÍAS)</div>
        <div style="font-size:26px;font-weight:800;color:${proximos.length>0?C.amber:C.text};">${proximos.length}</div>
      </div>
    </div>
  `;

  const cumplesHTML = proximos.length > 0 ? `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:10px;">
      <div style="font-weight:700;font-size:12px;margin-bottom:10px;color:${C.text};">🎂 Próximos cumpleaños</div>
      ${proximos.map(e => `
        <div style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid ${C.border};font-size:11.5px;">
          <div><strong>${escapeHTML(e.nombre)}</strong> ${e.cargo ? `<span style="color:${C.muted};">— ${escapeHTML(e.cargo)}</span>` : ""}</div>
          <div style="color:${e._dias===0?C.red:C.muted};font-weight:${e._dias===0?700:400};">${e._dias===0?"🎉 ¡Hoy!":(e._dias===1?"Mañana":`En ${e._dias} días`)} — ${fmtDate(e.fecha_cumpleanos)}</div>
        </div>
      `).join("")}
    </div>
  ` : "";

  const rows = filtered.map(e => `
    <tr style="border-top:1px solid ${C.border};">
      <td style="padding:6px 10px;font-weight:700;">${escapeHTML(e.nombre||"—")}</td>
      <td style="padding:6px 10px;">${e.cargo ? `<span style="background:#2B4A8218;color:#2B4A82;padding:2px 8px;border-radius:6px;font-size:10.5px;font-weight:600;white-space:nowrap;">${escapeHTML(CARGO_LABELS[e.cargo]||e.cargo)}</span>` : "—"}${e.es_vendedor && e.cargo !== "vendedor" ? ` <span title="También es vendedor: aparece como asesor comercial y entra en comisiones" style="background:#F59E0B18;color:#b45309;padding:2px 8px;border-radius:6px;font-size:10.5px;font-weight:700;white-space:nowrap;">🛒 vende</span>` : ""}</td>
      <td style="padding:6px 10px;">${escapeHTML(e.cedula||"—")}</td>
      <td style="padding:6px 10px;">${escapeHTML(e.telefono||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.email||"—")}</td>
      <td style="padding:6px 10px;">${e.fecha_cumpleanos ? fmtDate(e.fecha_cumpleanos) + (calcularEdad(e.fecha_cumpleanos)!=null ? ` (${calcularEdad(e.fecha_cumpleanos)} años)` : "") : "—"}</td>
      <td style="padding:6px 10px;">${escapeHTML(e.genero||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.eps||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.arl||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.fondo_pensiones||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.banco||"—")}</td>
      <td style="padding:6px 10px;font-size:10.5px;">${escapeHTML(e.cuenta_bancaria||"—")}</td>
      <td style="padding:6px 10px;text-align:right;white-space:nowrap;">
        <button data-action="edit-maestro" data-key="empleados" data-id="${e.id}" style="${btnStyle(null,"ghost",true)}">✏️</button>
        <button data-action="delete-maestro" data-key="empleados" data-id="${e.id}" style="${btnStyle(null,"ghost",true)}">🗑</button>
      </td>
    </tr>
  `).join("");

  return `
    ${header}
    ${statsHTML}
    ${cumplesHTML}
    <div style="margin-bottom:9px;">
      ${searchBox("search-empleados", query, "Buscar empleado por nombre, cédula, EPS, ARL...", "#2B4A82")}
      ${query ? `<div style="font-size:10.5px;color:${C.muted};margin-top:-8px;margin-bottom:8px;">Mostrando ${filtered.length} de ${empleados.length}</div>` : ""}
    </div>
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr style="background:#f1f5f9;">
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">NOMBRE</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">CARGO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">CÉDULA</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">TELÉFONO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">EMAIL</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">CUMPLEAÑOS</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">GÉNERO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">EPS</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">ARL</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">FONDO PENSIONES</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">BANCO</th>
            <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">CUENTA BANCARIA</th>
            <th></th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
  `;
}
